import { render, staticRenderFns } from "./editTeamRoleModal.vue?vue&type=template&id=71a799da&scoped=true&"
import script from "./editTeamRoleModal.vue?vue&type=script&lang=js&"
export * from "./editTeamRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./editTeamRoleModal.vue?vue&type=style&index=0&id=71a799da&scoped=true&lang=css&"
import style1 from "./editTeamRoleModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a799da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a799da')) {
      api.createRecord('71a799da', component.options)
    } else {
      api.reload('71a799da', component.options)
    }
    module.hot.accept("./editTeamRoleModal.vue?vue&type=template&id=71a799da&scoped=true&", function () {
      api.rerender('71a799da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/profile/modals/editTeamRoleModal.vue"
export default component.exports